import React, { useState, useEffect } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import { currency } from 'resources/utilities';
import ListTable from 'components/table/ListTable';
import TextField from '@mui/material/TextField';
import RenderButtons from 'components/table/RenderButtons';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import { useUIUtils } from 'hooks/useUIUtils';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';


const List = ({ history, match }) => {
    const { path } = match;
    const [fechaInicio, setFechaInicio] = useState(GetFecha(true));
    const [fechaFin, setFechaFin] = useState(GetFecha(false));
    const [tablaKey, setTablaKey] = useState(0);
    const { changeGlobalTitle } = useUIUtils();

    const [vxDoctocp, setVxDoctocp] = useState({});
    const [isOpenModal, openModal, closeModal] = useModal(false);
    const [isOpenCargoModal, openCargoModal, closeCargoModal] = useModal(false);
    const [isOpenAbonoModal, openAbonoModal, closeAbonoModal] = useModal(false);

    const [formasCobro, setFormasCobro] = useState([]);

    const [cargoModel, setCargoModel] = useState({
        sucursal_Id: getDataSession('sucursal'),
        proveedor_Id: 0,
        conceptos_Id: 0,
        condicion_Pago_Id: 0,
        folio: '',
        naturaleza_Concepto: 'C',
        descripcion: '',
        importe: 0,
        cancelado: 'N',
        aplicado: 'S',
        liquidado: 'N',
        moneda: 'MXN',
        fecha: GetFechaHoy()
    });

    const [abonoModel, setAbonoModel] = useState({
        sucursal_Id: getDataSession('sucursal'),
        proveedor_Id: 0,
        documento_CP_Id: 0,
        folio_Cargo: '',
        nombre_Proveedor: '',
        adeudo: 0,
        importe: 0,
        forma_Cobro_Cc_Id: 0,
        num_Cta_Pago: '',
        referencia: '',
        descripcion: '',
        naturaleza_Concepto: 'R',
        cancelado: 'N',
        aplicado: 'S',
        liquidado: 'S',
        moneda: 'MXN',
        fecha: GetFechaHoy()
    });

    useEffect(() => {
        changeGlobalTitle('Cargos', 'Listado de Cargos');
        loadCatalogos();
    }, [changeGlobalTitle]);

    async function loadCatalogos() {
        const sucursal = getDataSession('sucursal');
        const formas = await fetchConToken(`VxFormaCobroCc/GetList?paginas=0&totalXpagina=1000&sucursal_Id=${sucursal}`);
        const data = formas?.data || [];
        setFormasCobro(data);
        const predet = data.find(c => c.es_Predet === 'S' || c.es_predet === 'S') || data[0];
        if (predet?.id) {
            setAbonoModel(prev => ({
                ...prev,
                forma_Cobro_Cc_Id: prev.forma_Cobro_Cc_Id > 0 ? prev.forma_Cobro_Cc_Id : predet.id
            }));
        }
    }

    const verPagos = (docto_cp_id) => {
        fetchConToken(`VxDocumentosCP?id=${docto_cp_id}`).then(resp => {
            setVxDoctocp(resp || {});
        });
        openModal();
    };

    const abrirAbonar = (docto_cp_id) => {
        fetchConToken(`VxDocumentosCP?id=${docto_cp_id}`).then(resp => {
            if (!resp || resp.codigo) {
                Swal.fire('Error', resp?.mensajes?.[0] || 'No se pudo cargar el cargo', 'error');
                return;
            }
            const adeudo = parseFloat(resp.importe || 0) - parseFloat(resp.acreditado || 0);
            if (adeudo <= 0) {
                Swal.fire('Info', 'Este cargo ya esta liquidado', 'info');
                return;
            }
            setAbonoModel({
                sucursal_Id: getDataSession('sucursal'),
                proveedor_Id: resp.proveedor_Id,
                documento_CP_Id: resp.id,
                folio_Cargo: resp.folio,
                nombre_Proveedor: resp.nombre_Proveedor || resp.proveedor?.nombre || '',
                adeudo,
                importe: adeudo,
                forma_Cobro_Cc_Id: (formasCobro.find(c => c.es_Predet === 'S' || c.es_predet === 'S') || formasCobro[0])?.id || 0,
                num_Cta_Pago: '',
                referencia: '',
                descripcion: '',
                naturaleza_Concepto: 'R',
                cancelado: 'N',
                aplicado: 'S',
                liquidado: 'S',
                moneda: 'MXN',
                fecha: GetFechaHoy()
            });
            openAbonoModal();
        });
    };

    const abrirNuevoCargo = () => {
        setCargoModel({
            sucursal_Id: getDataSession('sucursal'),
            proveedor_Id: 0,
            conceptos_Id: 0,
            condicion_Pago_Id: 0,
            folio: '',
            naturaleza_Concepto: 'C',
            descripcion: '',
            importe: 0,
            cancelado: 'N',
            aplicado: 'S',
            liquidado: 'N',
            moneda: 'MXN',
            fecha: GetFechaHoy()
        });
        openCargoModal();
    };

    const columns = [
        { renderCell: RenderButtons, type: 'actions', headerName: '', maxWidth: 20, path: path, opciones: 'verPagos,abonar', verPagos: verPagos, abonar: abrirAbonar },
        { field: 'folio', headerName: 'Folio', minWidth: 100 },
        { field: 'nombre_Proveedor', headerName: 'Proveedor', minWidth: 220 },
        { field: 'fecha', headerName: 'Fecha', minWidth: 80, renderCell: ({ value }) => value?.substring(0, 10) },
        { field: 'cancelado', headerName: 'Cancelado', minWidth: 100 },
        { field: 'aplicado', headerName: 'Aplicado', minWidth: 100 },
        { field: 'liquidado', headerName: 'Liquidado', minWidth: 100 },
        { field: 'importe', headerName: 'Importe', minWidth: 100, type: 'number', renderCell: ({ value }) => currency(value) },
        { field: 'acreditado', headerName: 'Acreditado', minWidth: 110, type: 'number', renderCell: ({ value }) => currency(value) },
        { field: 'adeudo', headerName: 'Adeudo', minWidth: 110, type: 'number', renderCell: (params) => currency((params.row.importe || 0) - (params.row.acreditado || 0)) },
    ];

    const handleInputChangeFechaInicio = ({ target }) => {
        setFechaInicio(target.value);
    };

    const handleInputChangeFechaFin = ({ target }) => {
        setFechaFin(target.value);
    };

    function GetFecha(inicio) {
        var curr = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        if (!inicio) curr = new Date(curr.getFullYear(), curr.getMonth(), new Date(curr.getFullYear(), curr.getMonth() + 1, 0).getDate());

        curr.setDate(curr.getDate());
        return curr.toISOString().substring(0, 10);
    }

    function GetFechaHoy() {
        return new Date().toISOString().substring(0, 10);
    }

    const loadProveedores = async (query) => {
        if (getDataSession('sucursal') === '0') {
            Swal.fire('Info', 'Seleccione una conexion para continuar.', 'info');
            return [];
        }
        const resp = await fetchConToken(
            `VxProveedor/GetList?paginas=0&totalXpagina=50&busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}`
        );
        return resp.data || [];
    };

    const handleCargoChange = ({ target }) => {
        const numericFields = ['importe', 'proveedor_Id'];
        setCargoModel({
            ...cargoModel,
            [target.name]: numericFields.includes(target.name)
                ? parseFloat(target.value || 0)
                : target.value
        });
    };

    const handleAbonoChange = ({ target }) => {
        const numericFields = ['importe', 'forma_Cobro_Cc_Id'];
        setAbonoModel({
            ...abonoModel,
            [target.name]: numericFields.includes(target.name)
                ? parseFloat(target.value || 0)
                : target.value
        });
    };

    const guardarCargo = () => {
        if (!(cargoModel.proveedor_Id > 0)) {
            Swal.fire('Info', 'Seleccione un proveedor', 'info');
            return;
        }
        if (!(cargoModel.importe > 0)) {
            Swal.fire('Info', 'Capture un importe valido', 'info');
            return;
        }

        fetchConToken('VxDocumentosCP', cargoModel, 'POST').then(response => {
            if (response?.status === 400) {
                Object.entries(response.errors || {}).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');
                });
                return;
            }
            if (response?.codigo && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes?.[0] || 'No se pudo guardar', 'error');
                return;
            }
            Swal.fire('Exito', 'Cargo registrado', 'success');
            closeCargoModal();
            setTablaKey(prev => prev + 1);
        });
    };

    const guardarAbono = () => {
        if (!(abonoModel.forma_Cobro_Cc_Id > 0)) {
            Swal.fire('Info', 'Seleccione una forma de cobro', 'info');
            return;
        }
        if (!(abonoModel.importe > 0)) {
            Swal.fire('Info', 'Capture un importe de abono valido', 'info');
            return;
        }
        if (parseFloat(abonoModel.importe) > parseFloat(abonoModel.adeudo)) {
            Swal.fire('Info', 'El abono no puede ser mayor al adeudo', 'info');
            return;
        }

        const payload = {
            sucursal_Id: abonoModel.sucursal_Id,
            proveedor_Id: abonoModel.proveedor_Id,
            conceptos_Id: 0,
            naturaleza_Concepto: 'R',
            descripcion: abonoModel.descripcion,
            cancelado: 'N',
            aplicado: 'S',
            liquidado: 'S',
            moneda: abonoModel.moneda || 'MXN',
            fecha: abonoModel.fecha,
            forma_Cobro_Cc_Id: abonoModel.forma_Cobro_Cc_Id,
            num_Cta_Pago: abonoModel.num_Cta_Pago,
            referencia: abonoModel.referencia,
            Vx_Importe_CP: [{
                documento_CP_Id: abonoModel.documento_CP_Id,
                cancelado: 'N',
                aplicado: 'S',
                estatus: 'T',
                tipo_Importe: 'P',
                documento_CP_Acr_Id: 0,
                importe: abonoModel.importe,
                impuesto: 0,
                iva_Retenido: 0,
                isr_Retenido: 0,
                dscto_Pago: 0,
                moneda: abonoModel.moneda || 'MXN'
            }]
        };

        fetchConToken('VxDocumentosCP', payload, 'POST').then(response => {
            if (response?.status === 400) {
                Object.entries(response.errors || {}).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');
                });
                return;
            }
            if (response?.codigo && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes?.[0] || 'No se pudo guardar el abono', 'error');
                return;
            }
            Swal.fire('Exito', 'Abono registrado', 'success');
            closeAbonoModal();
            setTablaKey(prev => prev + 1);
        });
    };

    return (
        <>
            <div className='espacio10px' />
            <div className='container-fluid'>
                <div className='col-12 col-sm-12 col-md-12 row'>
                    <div className='col-sm-2'>
                        <button type='button' className='btn btn-outline-primary m-1' style={{ width: 'auto' }} onClick={abrirNuevoCargo}>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='18'
                                height='18'
                                fill='currentColor'
                                className='bi bi-plus-square'
                                viewBox='0 0 16 16'
                            >
                                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                            </svg>
                            &nbsp; Nuevo Cargo
                        </button>
                    </div>
                    <div className='col-sm-5' />
                    <div className='col-sm-5' style={{ display: 'flex' }}>
                        <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                            label="Fecha Inicio"
                            type="date"
                            value={fechaInicio}
                            onChange={handleInputChangeFechaInicio}
                            InputLabelProps={{ shrink: true, }}
                        />
                        <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                            label="Fecha Fin"
                            type="date"
                            value={fechaFin}
                            onChange={handleInputChangeFechaFin}
                            InputLabelProps={{ shrink: true, }}
                        />
                    </div>
                </div>
                <div className='col-md-12'>
                    <ListTable
                        columns={columns}
                        path={path}
                        reload={false}
                        url={`VxDocumentosCP/GetList?sucursal_Id=${getDataSession('sucursal')}&naturaleza_Concepto=C&liquidado=N&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}&_t=${tablaKey}`} />
                </div>
            </div>

            <Modal isOpen={isOpenModal} closeModal={closeModal} >
                <div className='col-md-12 row'>
                    <div className='col-md-4'>
                        <h4>Proveedor</h4>
                        <label>Proveedor:</label><p><label>{vxDoctocp?.proveedor?.nombre || vxDoctocp?.nombre_Proveedor}</label></p>
                        <label>Telefono:</label><p>{vxDoctocp?.proveedor?.telefono1}</p>
                        <label>Correo:</label><p>{vxDoctocp?.proveedor?.email || vxDoctocp?.proveedor?.correo}</p>
                    </div>
                    <div className='col-md-4'>
                        <label>Rfc:</label><p>{vxDoctocp?.proveedor?.rfc_Curp || vxDoctocp?.proveedor?.rfc}</p>
                    </div>
                    <div className='col-md-4'>
                        <label>Total Documento:</label><p>{currency(vxDoctocp?.importe)}</p>
                        <label>Acreditado:</label><p>{currency(vxDoctocp?.acreditado)}</p>
                        <label>Adeudo:</label><p>{currency((vxDoctocp?.importe || 0) - (vxDoctocp?.acreditado || 0))}</p>
                    </div>
                </div>
                <div className='col-md-12'>
                    <h4>Pagos</h4>
                    <div className='row' style={{ border: '1px solid black' }}>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Folio Concepto:</th>
                                    <th>Fecha:</th>
                                    <th>Importe:</th>
                                    <th>Inicial:</th>
                                    <th>Acreditado:</th>
                                    <th>Adeudo:</th>
                                    <th>Aplicado:</th>
                                    <th>Cancelado:</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vxDoctocp?.vx_Importe_CP?.map(x => (
                                    <tr key={x?.id || `${x?.folio_Concepto}-${x?.fecha}`}>
                                        <td>{x?.folio_Concepto}</td>
                                        <td>{x?.fecha?.substring?.(0, 10) || x?.fecha}</td>
                                        <td>{currency(x?.importe)}</td>
                                        <td>{currency(x?.adeudo)}</td>
                                        <td>{currency(x?.acreditado)}</td>
                                        <td>{currency((x?.adeudo || 0) - (x?.acreditado || 0))}</td>
                                        <td>{x?.aplicado}</td>
                                        <td>{x?.cancelado}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={isOpenCargoModal} closeModal={closeCargoModal} closeOnBackdrop={false}>
                <h4>Nuevo Cargo</h4>
                <div className='row text-start'>
                    <div className='col-md-6 mb-2'>
                        <label className='form-label'>Proveedor</label>
                        <AsyncSelect
                            className='react-select-placeholder'
                            isClearable
                            getOptionLabel={(option) => `${option.rfc_Curp || option.rfc || ''} - ${option.nombre || ''}`}
                            getOptionValue={(option) => option.id}
                            loadOptions={loadProveedores}
                            onChange={(selectedItem) => {
                                setCargoModel({
                                    ...cargoModel,
                                    proveedor_Id: selectedItem?.id || 0
                                });
                            }}
                        />
                    </div>
                    <div className='col-md-3 mb-2'>
                        <label className='form-label'>Fecha</label>
                        <input type='date' className='form-control' name='fecha' value={cargoModel.fecha} onChange={handleCargoChange} />
                    </div>
                    <div className='col-md-3 mb-2'>
                        <label className='form-label'>Folio (opcional)</label>
                        <input type='text' className='form-control' name='folio' value={cargoModel.folio} onChange={handleCargoChange} maxLength={9} placeholder='Se genera automatico' />
                    </div>
                    <div className='col-md-3 mb-2'>
                        <label className='form-label'>Importe</label>
                        <input type='number' className='form-control' name='importe' min='0' step='0.01' value={cargoModel.importe} onChange={handleCargoChange} />
                    </div>
                    <div className='col-md-12 mb-2'>
                        <label className='form-label'>Descripcion</label>
                        <textarea className='form-control' name='descripcion' value={cargoModel.descripcion} onChange={handleCargoChange} />
                    </div>
                    <div className='col-md-12 mt-2'>
                        <button type='button' className='btn btn-outline-success' onClick={guardarCargo}>Guardar Cargo</button>
                        &nbsp;
                        <button type='button' className='btn btn-outline-warning' onClick={closeCargoModal}>Cancelar</button>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={isOpenAbonoModal} closeModal={closeAbonoModal} closeOnBackdrop={false}>
                <h4>Abonar a Cargo</h4>
                <div className='row text-start'>
                    <div className='col-md-4 mb-2'>
                        <label className='form-label'>Folio</label>
                        <input type='text' className='form-control' value={abonoModel.folio_Cargo} disabled />
                    </div>
                    <div className='col-md-4 mb-2'>
                        <label className='form-label'>Proveedor</label>
                        <input type='text' className='form-control' value={abonoModel.nombre_Proveedor} disabled />
                    </div>
                    <div className='col-md-4 mb-2'>
                        <label className='form-label'>Adeudo</label>
                        <input type='text' className='form-control' value={currency(abonoModel.adeudo)} disabled />
                    </div>
                    <div className='col-md-4 mb-2'>
                        <label className='form-label'>Forma de cobro</label>
                        <select className='form-select' name='forma_Cobro_Cc_Id' value={abonoModel.forma_Cobro_Cc_Id} onChange={handleAbonoChange}>
                            <option value={0}></option>
                            {formasCobro.map(c => (
                                <option key={c.id} value={c.id}>{c.nombre}</option>
                            ))}
                        </select>
                    </div>
                    <div className='col-md-4 mb-2'>
                        <label className='form-label'>Importe a abonar</label>
                        <input type='number' className='form-control' name='importe' min='0' step='0.01' value={abonoModel.importe} onChange={handleAbonoChange} />
                    </div>
                    <div className='col-md-4 mb-2'>
                        <label className='form-label'>Fecha</label>
                        <input type='date' className='form-control' name='fecha' value={abonoModel.fecha} onChange={handleAbonoChange} />
                    </div>
                    <div className='col-md-6 mb-2'>
                        <label className='form-label'>No. cuenta pago</label>
                        <input type='text' className='form-control' name='num_Cta_Pago' maxLength={4} value={abonoModel.num_Cta_Pago} onChange={handleAbonoChange} />
                    </div>
                    <div className='col-md-6 mb-2'>
                        <label className='form-label'>Referencia</label>
                        <input type='text' className='form-control' name='referencia' maxLength={30} value={abonoModel.referencia} onChange={handleAbonoChange} />
                    </div>
                    <div className='col-md-12 mb-2'>
                        <label className='form-label'>Descripcion</label>
                        <textarea className='form-control' name='descripcion' value={abonoModel.descripcion} onChange={handleAbonoChange} />
                    </div>
                    <div className='col-md-12 mt-2'>
                        <button type='button' className='btn btn-outline-success' onClick={guardarAbono}>Guardar Abono</button>
                        &nbsp;
                        <button type='button' className='btn btn-outline-warning' onClick={closeAbonoModal}>Cancelar</button>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export { List };
